import { useQuery } from '../../hooks';
import { showToRoles } from '../../utils';
import { yardsService, clientYardService, belongsToOptions } from '../../services';
import { useStore } from '../../context';

const yardOptionsInitialData = {
  country: [],
  city: [],
  yard: [],
};

export const filterYardOptions = (
  data: { country: any[]; city: any[]; yard: any[] },
  country?: string,
  city?: string,
) => {
  let result = data;

  if (country) {
    result = { ...result, city: result.city.filter((obj: any) => country === obj.country) };
  }

  if (country || city) {
    result = {
      ...result,
      yard: result.yard.filter(
        (obj: any) => (!country || country === obj.country) && (!city || city === obj.city),
      ),
    };
  }

  return result;
};

export const useYardOptionsQuery = (
  keys: any = {},
  { user, yardCompanyId, clientId, country, city }: any,
  config?: Parameters<typeof useQuery>[2],
) => {
  const { data } = useQuery<any>(
    ['key', JSON.stringify({ ...keys })],
    () => {
      if (showToRoles(['YARD_MANAGER', 'YARD_DISPATCHER'], user)) return yardOptionsInitialData;

      if (showToRoles(['YARD_COMPANY_ADMIN', 'YARD_COMPANY_EMPLOYEE'], user) && !yardCompanyId)
        return yardOptionsInitialData;

      if (showToRoles(['YARD_COMPANY_ADMIN', 'YARD_COMPANY_EMPLOYEE'], user) && yardCompanyId)
        return yardsService.options({ yardCompanyId: yardCompanyId });

      if (showToRoles(['SUPER_ADMIN'], user)) return belongsToOptions.Yard('All', true);

      if (clientId) return clientYardService.assignedYards({ id: clientId }, user);

      return yardOptionsInitialData;
    },
    {
      initialData: yardOptionsInitialData,
      ...config,
    },
  );

  return {
    data: filterYardOptions(data, country, city),
  };
};

export const useYardBlocksQuery = (
  keys: any = {},
  props: any,
  config?: Parameters<typeof useQuery>[2],
) => {
  const {
    state: {
      user: { data: user },
    },
  } = useStore();
  const inventoryId = props.inventoryId || '';
  let queryKeys = JSON.stringify({ ...keys }) + inventoryId;

  if (showToRoles(['YARD_MANAGER', 'YARD_DISPATCHER', 'YARD_CRANE_OPERATOR'], user)) {
    props = { yardId: user.yardEmployee.yardId, inventoryId };
    queryKeys = props.yardId + (props.inventoryId || '');
  }

  Object.keys(props).forEach((key) => {
    if (!props[key]) delete props[key];
  });

  return useQuery(
    ['key', 'yard-blocks' + queryKeys],
    () => {
      if (!props.yardId && !props.containerId && !props.clientYardId) return [];

      return yardsService.getBlocks({ params: { ...props, notLoading: true } });
    },
    { initialData: [], ...config },
  );
};

export const useYardBlocksSceneQuery = (keys: any = {}, props: any) => {
  const {
    state: {
      user: { data: user },
    },
  } = useStore();

  if (showToRoles(['YARD_MANAGER', 'YARD_DISPATCHER', 'YARD_CRANE_OPERATOR'], user)) {
    props = { yardId: user.yardEmployee.yardId };
  }
  const queryKeys = showToRoles(['YARD_MANAGER', 'YARD_DISPATCHER', 'YARD_CRANE_OPERATOR'], user)
    ? props.yardId
    : JSON.stringify({ ...keys });

  Object.keys(props).forEach((key) => {
    if (!props[key]) delete props[key];
  });

  return useQuery(
    ['yard', 'yard-blocks-scene', queryKeys],
    () => {
      if (!props.yardId && !props.containerId && !props.clientYardId) return '';

      return yardsService.getBlocksScene({ params: { ...props } });
    },
    { initialData: '' },
  );
};
